import BeelineCloud from 'assets/illustrations/partners/beelineCloud.svg';
import YandexCloud from 'assets/illustrations/partners/yandexCloud.svg';
import Selectel from 'assets/illustrations/partners/selectel.svg';
import CloudRu from 'assets/illustrations/partners/cloud.ru.svg';
import K2Cloud from 'assets/illustrations/partners/k2Cloud.svg';
import VkCloud from 'assets/illustrations/partners/vkCloud.svg';
import Oxygen from 'assets/illustrations/partners/oxygen.svg';
import Nubes from 'assets/illustrations/partners/nubes.svg';

export const cloudMigrationPartnersPropsData = {
  title: 'Наши облачные партнёры',

  description:
    'Вместе с ведущими технологическими компаниями ASTON создаёт надёжные и масштабируемые решения',
  descriptionProps: { maxW: { tablet: '500px', laptop: '600px', desktop: '800px' } },

  cardsData: [
    { src: K2Cloud, alt: 'K2 Cloud' },
    { src: BeelineCloud, alt: 'beeline cloud' },
    { src: Oxygen, alt: 'Oxygen' },
    { src: Nubes, alt: 'nubes' },
    { src: YandexCloud, alt: 'Yandex Cloud' },
    { src: CloudRu, alt: 'cloud.ru' },
    { src: VkCloud, alt: 'VK Cloud' },
    { src: Selectel, alt: 'Selectel' },
  ],
};
